<template>
  <ul>
    <template v-if="loading">
      <b-skeleton
        v-for="i in 14"
        :key="i"
        class="mx-1 mt-2"
      />
    </template>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="(item, range) in items"
      v-show="!loading"
      :key="`${item.route}-${range}`"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import debounce from '@/mixins/debounce'
import {
  mapGetters,
} from 'vuex'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  mixins: [debounce],
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('verticalMenu/', ['loading']),
  },
  mounted() {
    setTimeout(() => {
      this.$store.commit('verticalMenu/setLoading', false)
    }, 1500)
  },
  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
    }
  },
}
</script>
